const Audio = () => {
  return (
    <audio
      id="beep"
      src="https://www.zapsplat.com/wp-content/uploads/2015/sound-effects-two/household_alarm_clock_beep_tone.mp3"
    />
  );
};

export default Audio;
